
import { chromeos_update_engine } from '@/services/update_metadata_pb'
import { defineComponent } from 'vue'
import { OpType, octToHex } from '../services/payload'
import OperationDetail from './OperationDetail.vue'

export default defineComponent({
  components: {
    OperationDetail
  },
  props: {
    partition: {
      type: chromeos_update_engine.PartitionUpdate,
      required: true
    },
    dynamicPartitionList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      showOPs: false,
      showInfo: false,
      opType: new OpType()
    }
  },
  methods: {
    toggle(key: string) {
      ;(this as any)[key] = !(this as any)[key]
    },
    octToHex: octToHex
  },
  computed: {
    readableTimestamp() {
      const unixTimestamp = parseInt(this.partition.version)
      if (isNaN(unixTimestamp)) {
        return ''
      }
      // Unix timestamp is in seconds, but js want milliseconds. So *1000
      return new Date(unixTimestamp * 1000).toString()
    },
    isDynamicPartition(): boolean {
      return (
        this.dynamicPartitionList.indexOf(this.partition.partitionName) >= 0
      )
    },
    isFECEnabled(): boolean {
      return (
        this.partition.fecExtent?.numBlocks > 0
      )
    },
    isHashtreeEnabled(): boolean {
      return (
        this.partition.hashTreeExtent?.numBlocks > 0
      )
    }
  }
})
